const store = {
    children: [
        {
            path: '/',
            name: 'indexPage',
            meta: {
                index: '/',
                title: "home",
                // is_keep: true
            },
            component: () => import('../views/indexPage.vue')
        },
        {
            path: '/aboutPage',
            name: 'aboutPage',
            meta: {
                index: '/',
                title: "About MANYC",
                // is_keep: true
            },
            component: () => import('../views/aboutPage.vue')
        },
        {
            path: '/ipCollections',
            name: 'ipCollections',
            meta: {
                index: '/',
                title: "IP & Collections",
            },
            component: () => import('../views/ipCollections.vue')
        },
        {
            path: '/newReleases',
            name: 'newReleases',
            meta: {
                index: '/',
                title: "New Releases",
            },
            component: () => import('../views/newReleases.vue')
        },
        {
            path: '/newReleasesDetail/:id',
            name: 'newReleasesDetail',
            meta: {
                index: '/',
                title: "Releases Detail",
            },
            component: () => import('../views/newReleasesDetail.vue')
        },
        {
            path: '/latestActivitiesDetail/:id',
            name: 'latestActivitiesDetail',
            meta: {
                index: '/',
                title: "Latest Activities",
            },
            component: () => import('../views/latestActivitiesDetail.vue')
        },
        {
            path: '/latestActivities',
            name: 'latestActivities',
            meta: {
                index: '/',
                title: "Latest Activities",
            },
            component: () => import('../views/latestActivities.vue')
        },
        {
            path: '/productsDetail',
            name: 'prouctsDetail',
            meta: {
                index: '/',
                title: "Products Detail",
            },
            component: () => import('../views/productsDetail.vue')
        },
    ]

}
export default store;